import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Jamelly - Beauty. God. Identity", 
  description = "The world through my eyes. Art pieces that represent God in my life, showing beauty and pain and joy and rain all at the same time.",
  image = "/images/site-photos/Cover1.png",
  url = "",
  type = "website"
}) => {
  const fullTitle = title === "Jamelly - Beauty. God. Identity" ? title : `${title} | Jamelly`;
  const fullUrl = url ? `https://jamelly.com${url}` : "https://jamelly.com";
  const fullImage = image.startsWith('http') ? image : `https://jamelly.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Jamelly" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      
      {/* Additional Meta Tags */}
      <meta name="author" content="Jamelly" />
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#885596" />
      
      {/* Favicon */}
      <link rel="icon" href="/images/site-photos/melly-favicon.png" />
      <link rel="apple-touch-icon" href="/images/site-photos/melly-favicon.png" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO; 